<template>
  <div
    class="vant-table"
    ref="vantTable"
  >
    <div class="content">
      <div class="title">商品选择</div>
      <van-search
        v-model="search.commodityName"
        @search="modalSearch"
        placeholder="请输入产品名称"
      />
      <div class="table">
        <div class="table-header">
          <div
            class="th"
            v-for="(item) in option.column"
            :key="item.key"
          >{{ item.title }}</div>
        </div>
        <div class="table-body">
          <div
            class="table-tr"
            v-for="(item, index) in dataList"
            :key="index"
          >
            <van-radio-group
              v-model="radio"
              direction="horizontal"
            >
              <van-radio :name="index"></van-radio>
            </van-radio-group>
            <div
              class="td"
              v-for="(context, i) in option.column"
              :key="i"
            >
              {{ item[context.key] }}
            </div>
          </div>
        </div>
      </div>
      <van-pagination
        @change="pageChange"
        v-model="pageInfo.currentPage"
        :total-items="pageInfo.total"
        :show-page-size="pageInfo.pageSize"
      >
        <template #prev-text>
          <van-icon name="arrow-left" />
        </template>
        <template #next-text>
          <van-icon name="arrow" />
        </template>
        <template #page="{ text }">{{ text }}</template>
      </van-pagination>
    </div>

    <div class="btn-order">
      <div class="card-btn">
        <van-button
          class="return"
          @click="returnBtn()"
        >取消</van-button>
        <van-button
          class="btn"
          @click="radioChangeConfirm()"
        >确认</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import BScroll from "better-scroll";
import transactionApi from "@/request/transactionApi";
export default {
  props: {
    params: {
      type: Object,
      showProduct: Boolean,
      default() {
        return {};
      },
    },
    sellerCode: {
      type: String,
      default() {
        return "";
      },
    },
    form: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      scroll: "",
      search: {
        commodityName: "",
      },
      pageInfo: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      keyword: "",
      abd: {
        currentPage: 1,
        pageSize: 10,
      },
      radioSelect: 0,
      dataList: [],
      radio: 0,
      option: {
        column: [
          { title: "产品名称", key: "commodityName" },
          { title: "规格牌号", key: "spec" },
          { title: "生产企业", key: "manufacturer" },
          // { title: "等级", key: "grade" },
          { title: "物料编码", key: "materialCode" },
        ],
      },
    };
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.scroll = new BScroll(this.$refs.vantTable, {
        scrollX: true,
        probeType: 3, // listening scroll hook
      });
    });
    this.getlist();
  },
  methods: {
    // 商品查询列表
    getlist() {
      // this.showModal = true;
      let params = {};
      params.currentPage = this.pageInfo.currentPage;
      params.pageSize = this.pageInfo.pageSize;
      params.commodityName = this.search.commodityName;
      // params.sellerName=this.form.sellerName

      transactionApi.getProductList(params).then((res) => {
        if (res.returnCode == "0") {
          for (var i in this.pageInfo) {
            this.pageInfo[i] = res.result[i];
          }
          this.dataList = res.result.dataList;
          this.pageInfo.total = res.result.totalRows;
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },

    modalSearch() {
      this.getlist();
    },
    pageChange(val) {
      this.pageInfo.currentPage = val;
      this.getlist();
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.pageInfo.currentPage = 1;
      this.getlist();
    },
    radioChangeConfirm() {
      let commodity = this.dataList[this.radioSelect];
      this.setFormData(commodity);
      this.showProduct = false;
      commodity.showProduct = this.showProduct;
      this.$emit("ProductSelect", commodity);
      this.$emit("showProduct", this.showProduct);
    },
    setFormData(commodity) {
      this.form.commodityName = commodity["commodityName"];
      this.form.materialCode = commodity["materialCode"];
      this.form.manufacturer = commodity["manufacturer"];
      this.form.batchNo = commodity["batchNo"];
      this.form.grade = commodity["grade"];
      this.form.measureUnit = commodity["measureUnit"];
      this.form.description = commodity["description"];
      this.form.spec = commodity["spec"];
      this.form.packing = commodity["packing"];
      this.form.commodityId = commodity["id"];
      this.form.topCateName = this.form.commodityCategoryName =
        commodity.topCatagory + "-" + commodity.middleCatagory;
      this.form.enterpriseName = commodity.sellerName;
      this.form.commoditySpec = commodity.spec;
      this.form.productionEnterprise = commodity.manufacturer;
      this.$emit("sureChange", { ...commodity, ...this.form });
    },
    returnBtn() {
      this.$emit("returnBtn");
    },
  },
};
</script>

<style lang="stylus" scoped>
.vant-table {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;

  .content {
    // padding: 30px;
    .title {
      font-size: 30px;
      margin-top: 30px;
      text-align: center;
    }
  }

  .content >>> .van-search {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    box-sizing: border-box;
    padding: 0.1rem 0.12rem;
    background-color: #fff;
    border: 1px solid #666;
    margin: 20px;
  }

  .content >>> .van-radio--horizontal {
    margin-right: 0;
  }

  .content >>> .van-radio-group--horizontal {
    display: inline-block;
  }

  .table {
    display: inline-block;
    font-size: 24px;
    overflow-x: auto;
    padding: 20px;

    .table-header {
      height: 74px;
      line-height: 74px;
      background-color: #F4F4F4;
    }

    .th, .td {
      display: inline-block;
      text-align: center;
      width: 150px;
    }

    .table-tr {
      height: 74px;
      line-height: 74px;
    }
  }

  .btn-order {
    width: 100%;
    margin-top: 30px;
    margin-bottom: 30px;
    font-size: 28px;

    .card-btn {
      width: 100%;
      text-align: right;

      .return {
        height: 50px;
        line-height: 50px;
        margin-right: 40px;
        background: #fff;
        border: 1px solid #e12020;
        color: #e12020;
        border-radius: 20px;
      }

      .btn {
        margin-right: 40px;
        height: 50px;
        line-height: 50px;
        background: #e12020;
        color: #fff;
        border-radius: 20px;
      }

      .van-button__text {
        padding: 40px;
      }
    }
  }
}
</style>